import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiConnectorService } from 'src/app/___LOGIC/__api/api-connector.service';

@Component({
  selector: 'app-smart-select',
  templateUrl: './smart-select.component.html',
  styleUrls: ['./smart-select.component.css']
})
export class SmartSelectComponent implements OnInit {

  @Input() tableName;
  @Output() public selectedObj = new EventEmitter();
  
  editingMode = false;
  elements;
    // GUI Values
    inputLabel;
    inputHint;
    inputValue = '';
    placeholder = '';

    data;
    displayedValue1 = 'name';
    displayedValue2 = 'lastname';
    selectOptionValue = 'id';
  
  constructor(private apiConnector: ApiConnectorService) { }

  ngOnInit(): void {
    // GUI
    this.inputLabel = this.tableName;
    this.getComboboxOptions();
  }

  getComboboxOptions(){
    /* if (this.rootScope.isCacheEmpty('serviceCategory')){ */
      this.apiConnector.simpleQueryId('get', this.tableName,null,null,null,null)
      .subscribe(response => this.saveDataToLocalClass(response));
    /* }else{
      this.categories = this.rootScope.getComponentCache('serviceCategory');
    } */
  }

  saveDataToLocalClass(response){
    //this.props = response.props;
    this.elements = response.records;
  }

  updateSelection(selection: any){
    this.inputValue = selection.name + ' '+selection.lastname;
    this.selectedObj.emit(selection);
    this.editingMode = false;
    /* this.crudFieldsData.addValueToFieldInObj(this.data.fieldName, this.inputValue,this.data.crudId); */
  }

}
